'use client';

import * as Sentry from '@sentry/browser';
import { Component } from 'react';

interface IPaletteErrorBoundaryProps {
  children: React.ReactNode;
}

interface IPaletteErrorBoundaryState {
  hasError: boolean;
}

export class PaletteErrorBoundary extends Component<
  IPaletteErrorBoundaryProps,
  IPaletteErrorBoundaryState
> {
  public override state: IPaletteErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): IPaletteErrorBoundaryState {
    return { hasError: true };
  }

  public override componentDidCatch(error: Error): void {
    Sentry.captureException(error);
  }

  public override render(): React.ReactNode {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
